module.exports = __webpack_public_path__ + "static/media/img2.f1b20000.jpeg";